export default __webpack_public_path__ + "static/media/statsHeader.39999c5d.jpg";